<template>
  <div>
    <div class="action d-flex justify-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="() => openBillDetail(kind)" v-bind="attrs" v-on="on">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <span class="white--text">Xem chi tiết hoá đơn</span>
      </v-tooltip>
    </div>
    <DetailedBillDialog ref="detail-bill" />
    <DetailBillDialog ref="detail-bill-dialog" />
  </div>
</template>
<script>
import DetailedBillDialog from './detailedBillDialog.vue'
import DetailBillDialog from './DetailBillDialog.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    report: Object,
    viewIsPaid: Boolean,
    isPaid: Boolean,
    kind: String
  },
  data() {
    return {
      isEditNote: false,
      isOpenDialog: false
    }
  },
  components: {
    DetailedBillDialog,
    DetailBillDialog
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod'
    })
  },
  methods: {
    ...mapActions({
      setReport: 'tuitionFeeReport/setReport',
      editStatusPaid: 'tuitionFeeReport/editStatusPaid'
    }),
    openBillDetail(kind) {
      this.setReport(this.report)
      let ref = 'detail-bill-dialog'
      this.$refs[ref].openDialog(kind)
    }
  }
}
</script>
<style lang="scss" scoped>
.action {
  min-width: 30px;
}
</style>
